<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <vxe-input v-model="query['container.no']" class="query" clearable placeholder="business.label.no" size="small" @pressEnter="search"/>
      <vxe-select v-model="query['containerType.id']" :options="containerTypes" class="query" clearable placeholder="business.label.containerType" size="small"/>
      <vxe-switch v-model="query.available" close-label="禁用" open-label="可用"/>
      <vxe-switch v-model="query.physical" close-label="虚拟" open-label="物理"/>
      <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="search"/>
      <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
      <a-divider type="vertical"/>
      <vxe-button content="button.save" icon="vxe-icon-save" size="mini" status="primary" @click="save"/>
      <vxe-button content="button.add" icon="vxe-icon-add" size="mini" status="primary" @click="add"/>
      <a-divider type="vertical"/>
      <vxe-input v-model="args.begin" class="query" clearable placeholder="business.label.beginNo" size="small"/>
      <vxe-input v-model="args.end" class="query" clearable placeholder="business.label.endNo" size="small"/>
      <vxe-button content="button.batchAddContainer" size="mini" status="primary" @click="batchSave"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :edit-config="editConfig"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      keep-source
      :edit-rules="editRules"
      :height="height"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="no" title="business.label.no"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="name" title="business.label.name"/>
      <vxe-column :cell-render="{name:'VxeSelect',options:containerTypes}" field="containerType.name" title="business.label.containerType"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="available" title="business.label.available" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="physical" title="business.label.physical" width="70"/>
      <vxe-column field="carrier.name" title="business.label.carrier"/>
      <vxe-column field="currentPosition.no" title="business.label.currentPosition"/>
      <vxe-column field="lastPosition.no" title="business.label.lastPosition"/>
      <vxe-column field="taskId" title="business.label.taskId"/>
      <vxe-column :cell-render="{name:'FormatSelect',options:operationTypes}" field="operationType" title="business.label.operationType" width="70"/>
      <vxe-column field="traceNo" title="business.label.traceNo"/>
      <vxe-column field="pickingOrder.no" title="business.label.pickingOrder"/>
      <vxe-column field="destination.no" title="business.label.destination"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
    <container-type-modal ref="containerTypeModal" @change="(e,row)=>row.containerType=new ContainerType(e[0])"/>
  </a-layout>
</template>

<script>
import Vue from 'vue'
import api from '@/api'
import { findAll, findEnum, post, saveAll } from '@/api/Api'
import ContainerTypeModal from '@/views/modal/ContainerTypeModal.vue'
import { SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import { Container } from '@/api/dto/common/Container'
import { ContainerType } from '@/api/dto/common/ContainerType'

export default {
    name: 'ContainerMaintain',
    computed: {
      ContainerType() {
        return ContainerType
      }
    },
    components: { ContainerTypeModal },
    data() {
      return {
        warehouse: Vue.ls.get(WAREHOUSE),
        loading: false,
        data: [],
        query: { 'container.no': '', available: true, 'containerType.id': undefined, physical: true },
        args: { 'containerType.id': undefined, physical: true, begin: '', end: '' },
        page: 1,
        size: 20,
        contentSize: 0,
        operationTypes: [],
        containerTypes: [],
        height: Vue.ls.get(SCREEN_HEIGHT) * (0.815),
        editConfig: { trigger: 'click', mode: 'cell', showStatus: true },
        editRules: {
          no: [
            { required: true, type: 'string', message: '编号不能为空' }
          ],
          name: [
            { required: true, type: 'string', message: '名称不能为空' }
          ]
        }
      }
    },
    created() {
      findEnum('OperationType').then(res => {
        if (res.success) {
          this.operationTypes = res.result.map(item => {
            return { label: item.name, value: item.ordinal }
          })
        }
      })
      findAll('containerTypeFactory').then(res => {
        if (res.success) {
          this.containerTypes = res.result.map(item => {
            return { label: item.name, value: item.id }
          })
        }
      })
    },
    activated() {
      this.refresh()
    },
    methods: {
      pageChange({ currentPage, pageSize }) {
        this.page = currentPage
        this.size = pageSize
        this.refresh()
      },
      openModal(modal, args, e) {
        this.$refs[modal].open(args, e)
      },
      onContainerTypeClicked(row) {
        this.openModal('containerTypeModal', { available: true }, row)
      },
      add() {
        this.data.push(new Container())
      },
      refresh() {
        this.loading = true
        this.data = []
        findAll('containerFactory', this.query, this.page, this.size).then(res => {
          if (res.success) {
            this.contentSize = res.contentSize
            this.data = res.result.map(item => {
              return new Container(item)
            })
          }
        }).finally(() => this.loading = false)
      },
      search() {
        this.page = 1
        this.refresh()
      },
      reset() {
        this.query = { 'container.no': '', available: true, 'containerType.id': undefined, physical: true }
        this.page = 1
        this.size = 20
        this.data = []
      },
      async save() {
        const errMap = await this.$refs.table.validate(true)
        if (errMap) {
          return
        }
        const { insertRecords, updateRecords } = this.$refs.table.getRecordset()
        let saveData = insertRecords.concat(updateRecords)
        if (saveData.length > 0) {
          this.loading = true
          saveData = saveData.map(item => {
            item.warehouse = this.warehouse
            return item.toJSONObject()
          })
          saveAll('containerPersister', saveData).then(res => {
            if (res.success) {
              this.refresh()
              this.$message.success('保存成功')
            }
          }).finally(() => this.loading = false)
        } else {
          this.$message.warning('无数据可保存')
        }
      },
      batchSave() {
        this.args['containerType.id'] = this.query['containerType.id']
        this.args.physical = this.query.physical
        if (this.args['containerType.id'] === undefined) {
          this.$message.warning('请选择容器类型')
          return
        }
        this.loading = true
        post(api.batchSave, { type: 'containerPersister' }, this.args).then(res => {
          if (res.success) {
            this.refresh()
            this.$message.success('批量新增成功')
          }
        }).finally(() => this.loading = false)
      }
    }
  }
</script>
<style scoped>
  .query {
    width: 150px;
  }
</style>